export default __webpack_public_path__ + "static/media/Delete_D.19b82219.svg";